module.exports = __webpack_public_path__ + "img/menu-on_02.8a26ff5c.png";